import React, { useEffect, useState } from "react";
import { StyleSheet, View, ScrollView } from "react-native";
import { Container, Typography, Input, Button } from "src/components";
import { useForm } from "react-hook-form";
import { IError } from "src/components/dialog/error";
import * as formValidators from "src/utils/form-validator";
import { Auth } from "aws-amplify";
import { updateCognitoEmailEventEmit } from "src/utils/event";
import LocalText from "src/local";

type Props = {
  email: string;
  onDone: () => void;
};

type FormValues = {
  code: string;
};

export const Confirm: React.FC<Props> = (props) => {
  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>({
    defaultValues: { code: "" },
  });
  const [error, setError] = useState<IError | null>(null);
  const [processed, setProcessed] = useState<boolean>(false);
  useEffect(() => {
    register("code", {
      validate: (value) => {
        if (!formValidators.RequireValidator(value)) {
          return "require";
        }
        // TODO: Add code pattern
        return true;
      },
    });
  }, [register]);
  const onConfirm = async (data: FormValues) => {
    setProcessed(true);
    try {
      await Auth.verifyCurrentUserAttributeSubmit("email", data.code);
      updateCognitoEmailEventEmit();
      setProcessed(false);
      props.onDone();
    } catch (e) {
      console.error(e);
      setError(e as Error);
      setProcessed(false);
    }
  };
  return (
    <Container style={styles.container} loading={processed}>
      <ScrollView>
        <Typography
          text={LocalText.screens.myAccountEmail.confirm.description}
          variant={"section"}
        />
        <Input
          placeholder={LocalText.screens.myAccountEmail.confirm.code}
          name={"code"}
          control={control}
          error={errors.code?.message}
          keyboardType={"number-pad"}
          autoCapitalize={"none"}
        />
        <View style={styles.buttonContainer}>
          <Button
            title={LocalText.common.done}
            loading={processed}
            onPress={handleSubmit(onConfirm)}
          />
        </View>
      </ScrollView>
    </Container>
  );
};

const styles = StyleSheet.create({
  container: {},
  buttonContainer: {
    flexDirection: "column",
    marginTop: 36,
    marginHorizontal: 16,
  },
});
